import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import PrivacyPolicyLink from '@sputnik/components/PrivacyPolicyLink'
import { PRODUCT_CONST_STRINGS, URL } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

const DashboardFooter = () => {
  const [getClassName] = useNameFormatter('DashboardFooter')
  const { track } = useWebTracking()

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('links')]}>
        <TextLink
          href={URL.BILL_LEGAL_LINK}
          target='_blank'
          onClick={() => {
            track('se_signup__application_dashboard_home_legal_link__fired')
          }}
        >
          <FormattedMessage
            defaultMessage='Legal'
            id='sputnik.DashboardFooter__7oFrM6'
          />
        </TextLink>
        <PrivacyPolicyLink
          alternateLinkString={
            <FormattedMessage
              defaultMessage='Privacy'
              id='sputnik.DashboardFooter__cXBJ7U'
            />
          }
          onClick={() => {
            track('se_signup__application_dashboard_home_privacy_link__fired')
          }}
        />
        <TextLink
          href={URL.BILL_SECURITY_LINK}
          target='_blank'
          onClick={() => {
            track('se_signup__application_dashboard_home_security_link__fired')
          }}
        >
          <FormattedMessage
            defaultMessage='Security'
            id='sputnik.DashboardFooter__Py189G'
          />
        </TextLink>
        <TextLink
          href={URL.BILL_HELP_CENTER_LINK}
          target='_blank'
          onClick={() => {
            track('se_signup__application_dashboard_home_help_center_link__fired')
          }}
        >
          <FormattedMessage
            defaultMessage='Help Center'
            id='sputnik.DashboardFooter__HtSDyc'
          />
        </TextLink>
        <div className={styles[getClassName('sign-in')]}>
          <FormattedMessage
            defaultMessage='Already a {BILL_SPEND_AND_EXPENSE} user?'
            id='sputnik.DashboardFooter__oB29Xv'
            values={{
              BILL_SPEND_AND_EXPENSE: PRODUCT_CONST_STRINGS.BILL_SPEND_AND_EXPENSE,
            }}
          />
          <TextLink
            href={URL.DIVVY_PROD}
            size={TextLinkSizes.REGULAR}
            target='_blank'
            onClick={() => {
              track('se_signup__application_dashboard_home_log_in_here_link__fired')
            }}
          >
            <FormattedMessage
              defaultMessage='Log in here'
              id='sputnik.DashboardFooter__2SvpuI'
            />
          </TextLink>
        </div>
      </div>
      <div className={styles[getClassName('copyright')]}>
        <FormattedMessage
          defaultMessage='© 2025 {BILL} Operations, LLC'
          id='sputnik.DashboardFooter__k28y/w'
          values={{
            BILL: PRODUCT_CONST_STRINGS.BILL,
          }}
        />
      </div>
    </div>
  )
}

export default DashboardFooter
